import React, { useState, useRef } from "react";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import registerimg from "../Assets/images/registerimgnew.png";
import group14 from "../Assets/images/Group-14.png";
import unitycuplogo from "../Assets/images/Unity_4.png";
import QRcodebank from "../Assets/images/QRcodebank.png"
import alconlogo from "../Assets/images/alcon_logo.png";

const STEP_LABELS = ["Personal Info", "Documents", "Player Details", "Availability & Agreement"];

function FileDropzone({
    label,
    hint,
    accept,
    file,
    files,
    multiple = false,
    dragActive,
    inputId,
    onInputChange,
    onDrop,
    onDragOver,
    onDragLeave,
    onRemove,
    error,
    theme = "dark",
}) {
    const previewKind = file && file.type && file.type.startsWith("image/") ? "image" : "document";
    const isLight = theme === "light";
    const fileList = multiple ? (files || []) : [];
    return (
        <div style={{ width: "100%", textAlign: "left" }}>
            <label style={{ color: isLight ? "#222" : "white", display: "block", marginBottom: "5px" }}>{label}</label>
            <div
                onDrop={onDrop}
                onDragOver={onDragOver}
                onDragLeave={onDragLeave}
                onClick={() => document.getElementById(inputId).click()}
                style={{
                    border: `2px dashed ${dragActive ? "#2DB9CA" : isLight ? "rgba(0,0,0,0.25)" : "rgba(255,255,255,0.4)"}`,
                    borderRadius: "8px",
                    padding: "16px",
                    textAlign: "center",
                    cursor: "pointer",
                    backgroundColor: dragActive ? "rgba(45,185,202,0.15)" : isLight ? "rgba(0,0,0,0.03)" : "rgba(255,255,255,0.05)",
                    transition: "all 0.2s ease",
                }}
            >
                <input
                    id={inputId}
                    type="file"
                    accept={accept}
                    multiple={multiple}
                    onChange={onInputChange}
                    style={{ display: "none" }}
                />
                {!multiple && file ? (
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "10px", flexWrap: "wrap" }}>
                        {previewKind === "image" ? (
                            <img
                                src={file.data}
                                alt="preview"
                                style={{ width: "48px", height: "48px", objectFit: "cover", borderRadius: "6px" }}
                            />
                        ) : (
                            <span style={{ fontSize: "28px" }}>📄</span>
                        )}
                        <span style={{ fontSize: "14px", wordBreak: "break-all", color: isLight ? "#222" : "white" }}>{file.name}</span>
                        <button
                            type="button"
                            onClick={(e) => { e.stopPropagation(); onRemove(); }}
                            style={{ background: "none", border: "none", color: "#ff6b6b", fontSize: "18px", cursor: "pointer", lineHeight: 1 }}
                            aria-label={`Remove ${label}`}
                        >
                            ×
                        </button>
                    </div>
                ) : (
                    <span style={{ fontSize: "14px", color: isLight ? "#555" : "#ddd" }}>
                        {multiple && fileList.length > 0 ? "Add another file, or " : "Drag & drop a file here, or "}
                        <span style={{ color: "#2299a8", textDecoration: "underline" }}>click to browse</span>
                    </span>
                )}
            </div>
            {multiple && fileList.length > 0 && (
                <div style={{ marginTop: "8px", display: "flex", flexDirection: "column", gap: "6px" }}>
                    {fileList.map((f, index) => (
                        <div
                            key={index}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                                padding: "6px 10px",
                                borderRadius: "6px",
                                backgroundColor: isLight ? "rgba(0,0,0,0.04)" : "rgba(255,255,255,0.08)",
                            }}
                        >
                            {f.type && f.type.startsWith("image/") ? (
                                <img
                                    src={f.data}
                                    alt="preview"
                                    style={{ width: "36px", height: "36px", objectFit: "cover", borderRadius: "6px", flexShrink: 0 }}
                                />
                            ) : (
                                <span style={{ fontSize: "22px" }}>📄</span>
                            )}
                            <span style={{ fontSize: "13px", wordBreak: "break-all", color: isLight ? "#222" : "white", flex: 1 }}>{f.name}</span>
                            <button
                                type="button"
                                onClick={() => onRemove(index)}
                                style={{ background: "none", border: "none", color: "#ff6b6b", fontSize: "18px", cursor: "pointer", lineHeight: 1, flexShrink: 0 }}
                                aria-label={`Remove ${f.name}`}
                            >
                                ×
                            </button>
                        </div>
                    ))}
                </div>
            )}
            {hint && (
                <p style={{ fontSize: "12px", color: isLight ? "#666" : "#ccc", marginTop: "4px", marginBottom: 0, textAlign: "left" }}>
                    {hint}
                </p>
            )}
            {error && (
                <p style={{ fontSize: "12px", color: "#ff6b6b", marginTop: "4px", marginBottom: 0, textAlign: "left" }}>
                    {error}
                </p>
            )}
        </div>
    );
}

function Register() {
    const [submitting, setSubmitting] = useState(false);
    const [submittingPayLater, setSubmittingPayLater] = useState(false);
    const [playerProfile, setPlayerProfile] = useState("");
    const [specialization, setSpecialization] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [showConsentModal, setShowConsentModal] = useState(false);
    const [uploadedImages, setUploadedImages] = useState([]);
    const [profileFile, setProfileFile] = useState(null);
    const [documentFiles, setDocumentFiles] = useState([]);
    const [showTooltip, setShowTooltip] = useState(false);
    const [currentStep, setCurrentStep] = useState(0);
    const [docErrors, setDocErrors] = useState({});
    const [dragActive, setDragActive] = useState({ profile: false, aadhaar: false, screenshot: false });
    const formRef = useRef(null);
    const formElementRef = useRef(null);
    const stepRefs = [useRef(null), useRef(null), useRef(null), useRef(null)];

    // Check if registration is open (enabled)
    const isRegistrationOpen = true; // Registration open

    const validateStep = (index) => {
        const container = stepRefs[index].current;
        if (!container) return true;
        const fields = container.querySelectorAll("input, select, textarea");
        for (const field of fields) {
            if (field.disabled) continue;
            if (!field.checkValidity()) {
                field.reportValidity();
                field.focus();
                return false;
            }
        }
        return true;
    };

    const validateDocumentsStep = () => {
        const errors = {};
        if (!profileFile) errors.profile = "Please upload a profile picture.";
        if (!documentFiles.length) errors.aadhaar = "Please upload your Aadhaar document.";
        setDocErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const handleNext = () => {
        const stepValid = currentStep === 1 ? validateDocumentsStep() : validateStep(currentStep);
        if (!stepValid) return;
        setCurrentStep((s) => Math.min(s + 1, STEP_LABELS.length - 1));
    };

    const handleBack = () => {
        setCurrentStep((s) => Math.max(s - 1, 0));
    };

    const handleFormKeyDown = (e) => {
        if (e.key === "Enter" && currentStep < STEP_LABELS.length - 1) {
            e.preventDefault();
        }
    };

    // Downscales/re-encodes images before upload so large phone-camera photos
    // (often 5-10MB) don't turn into slow, oversized base64 payloads that the
    // Apps Script has to parse and write to Drive. PDFs pass through untouched.
    const compressImage = (file, maxDimension = 1280, quality = 0.8) =>
        new Promise((resolve) => {
            if (!file.type.startsWith("image/")) {
                resolve(file);
                return;
            }
            const objectUrl = URL.createObjectURL(file);
            const img = new Image();
            img.onload = () => {
                let { width, height } = img;
                if (width > maxDimension || height > maxDimension) {
                    const scale = maxDimension / Math.max(width, height);
                    width = Math.round(width * scale);
                    height = Math.round(height * scale);
                }
                const canvas = document.createElement("canvas");
                canvas.width = width;
                canvas.height = height;
                canvas.getContext("2d").drawImage(img, 0, 0, width, height);
                canvas.toBlob(
                    (blob) => {
                        URL.revokeObjectURL(objectUrl);
                        if (!blob) {
                            resolve(file);
                            return;
                        }
                        const compressedName = file.name.replace(/\.\w+$/, "") + ".jpg";
                        resolve(new File([blob], compressedName, { type: "image/jpeg" }));
                    },
                    "image/jpeg",
                    quality
                );
            };
            img.onerror = () => {
                URL.revokeObjectURL(objectUrl);
                resolve(file);
            };
            img.src = objectUrl;
        });

    const handleInitialSubmit = (event) => {
        event.preventDefault();
        formRef.current = new FormData(event.target);
        setShowModal(true);
    };

    const handleFinalSubmit = async () => {
        setSubmitting(true);
        const url =
            "https://script.google.com/macros/s/AKfycbyYp3zc_Hl5X8Np51EndJD5NTDkMxnnyF_xY88jCu16HDiR0TToY-YrE9bJlyF9g40_/exec";

        try {
            formRef.current.append("Payment-Status", "Payment Done");

            uploadedImages.forEach((img, index) => {
                formRef.current.append(`Screenshot-${index + 1}`, img.data);
                formRef.current.append(`Screenshot-${index + 1}-Type`, img.type);
                formRef.current.append(`Screenshot-${index + 1}-Name`, img.name);
            });
            if (profileFile) {
                formRef.current.append("Profile-Picture", profileFile.data);
                formRef.current.append("Profile-Picture-Type", profileFile.type);
                formRef.current.append("Profile-Picture-Name", profileFile.name);
            }
            documentFiles.forEach((file, index) => {
                formRef.current.append(`Document-${index + 1}`, file.data);
                formRef.current.append(`Document-${index + 1}-Type`, file.type);
                formRef.current.append(`Document-${index + 1}-Name`, file.name);
            });

            // First, submit the form data
            const response = await fetch(url, {
                method: "POST",
                body: formRef.current,
            });

            if (!response.ok) {
                throw new Error("Network response was not ok");
            }

            const data = await response.json();
            console.log("Form data sent successfully:", data);
            // Confirmation email is sent server-side by the Apps Script
            // (GmailApp.sendEmail in Code.gs) — no need to also call the
            // Netlify email function here, which only added latency and sent
            // a duplicate email.

            const excelRecord = {
                ...Object.fromEntries(formRef.current),
                "Payment-Status": "Payment Done",
                "Profile-Picture-URL": data.profilePictureUrl || "N/A",
                "Screenshot-URL": data.screenshotUrl || "N/A",
                "Documents": data.documentUrls ? data.documentUrls.join(", ") : "N/A",
                "Timestamp": new Date().toISOString(),
            };
            console.log("Excel Record (Payment Done):", excelRecord);

            formRef.current = null;
            setPlayerProfile("");
            setSpecialization("");
            setUploadedImages([]);
            setProfileFile(null);
            setDocumentFiles([]);
            setDocErrors({});
            setCurrentStep(0);
            setShowModal(false);
            setShowTooltip(false);
            setSubmitting(false);
            formElementRef.current.reset();

            // Show success toast
            toast.success("Registration has been done successfully!", {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                style: {
                    background: '#28a745',
                    color: 'white',
                },
                progressStyle: {
                    background: '#ffffff',
                },
            });
        } catch (error) {
            console.error("Error:", error);
            // Show error toast
            toast.error("Registration failed. Please try again.", {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                style: {
                    background: '#dc3545',
                    color: 'white',
                },
                progressStyle: {
                    background: '#ffffff',
                },
            });
        } finally {
            setSubmitting(false);
        }
    };
    const handlePayLater = async () => {
        setSubmittingPayLater(true);
        const url =
            "https://script.google.com/macros/s/AKfycbxzy6pzYra198-lISG8JXzNIu307L0d4s8RA_Vy8YKIU5vmWU-ZSrHKvipsYivaTkzPLw/exec";

        try {
            formRef.current.append("Payment-Status", "Payment Pending");
            if (profileFile) {
                formRef.current.append("Profile-Picture", profileFile.data);
                formRef.current.append("Profile-Picture-Type", profileFile.type);
                formRef.current.append("Profile-Picture-Name", profileFile.name);
            }
            documentFiles.forEach((file, index) => {
                formRef.current.append(`Document-${index + 1}`, file.data);
                formRef.current.append(`Document-${index + 1}-Type`, file.type);
                formRef.current.append(`Document-${index + 1}-Name`, file.name);
            });

            const response = await fetch(url, {
                method: "POST",
                body: formRef.current,
            });

            if (!response.ok) {
                throw new Error("Network response was not ok");
            }

            const data = await response.json();
            console.log("Form data sent successfully (Pay Later):", data);

            const excelRecord = {
                ...Object.fromEntries(formRef.current),
                "Payment-Status": "Payment Pending",
                "Profile-Picture-URL": data.profilePictureUrl || "N/A",
                "Screenshot-URL": "N/A",
                "Documents": data.documentUrls ? data.documentUrls.join(", ") : "N/A",
                "Timestamp": new Date().toISOString(),
            };
            console.log("Excel Record (Payment Pending):", excelRecord);

            formRef.current = null;
            setPlayerProfile("");
            setSpecialization("");
            setUploadedImages([]);
            setProfileFile(null);
            setDocumentFiles([]);
            setDocErrors({});
            setCurrentStep(0);
            setShowModal(false);
            setShowTooltip(false);
            formElementRef.current.reset();
        } catch (error) {
            console.error("Error sending form data (Pay Later):", error);
        } finally {
            setSubmittingPayLater(false);
        }
    };

    const handlePlayerProfileChange = (event) => {
        setPlayerProfile(event.target.value);
        setSpecialization("");
    };

    const handleSpecializationChange = (event) => {
        setSpecialization(event.target.value);
    };

    const processScreenshotFiles = async (files) => {
        if (!files.length) return;
        const compressedFiles = await Promise.all(files.map((file) => compressImage(file)));
        const filePromises = compressedFiles.map((file) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            return new Promise((resolve) => {
                reader.onload = () => resolve({
                    data: reader.result,
                    name: file.name,
                    type: file.type,
                });
            });
        });
        const results = await Promise.all(filePromises);
        setUploadedImages((prev) => [...prev, ...results]);
    };

    const handleImageUpload = (event) => {
        processScreenshotFiles(Array.from(event.target.files));
        event.target.value = "";
    };

    const handleScreenshotDrop = (event) => {
        event.preventDefault();
        setDragActive((prev) => ({ ...prev, screenshot: false }));
        processScreenshotFiles(Array.from(event.dataTransfer.files));
    };

    const handleRemoveScreenshot = (index) => {
        setUploadedImages((prev) => prev.filter((_, i) => i !== index));
    };

    const processProfileFile = async (file) => {
        if (!file) return;
        const compressed = await compressImage(file);
        const reader = new FileReader();
        reader.onload = () => {
            setProfileFile({
                data: reader.result,
                name: compressed.name,
                type: compressed.type,
            });
            setDocErrors((prev) => ({ ...prev, profile: null }));
        };
        reader.readAsDataURL(compressed);
    };

    const handleProfileUpload = (event) => processProfileFile(event.target.files[0]);

    const handleProfileDrop = (event) => {
        event.preventDefault();
        setDragActive((prev) => ({ ...prev, profile: false }));
        processProfileFile(event.dataTransfer.files[0]);
    };

    const handleRemoveProfileFile = () => {
        setProfileFile(null);
        const input = document.getElementById("profile-picture-input");
        if (input) input.value = "";
    };

    const processDocumentFiles = async (files) => {
        if (!files.length) return;
        const compressedFiles = await Promise.all(files.map((file) => compressImage(file)));
        const filePromises = compressedFiles.map((file) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            return new Promise((resolve) => {
                reader.onload = () => resolve({
                    data: reader.result,
                    name: file.name,
                    type: file.type,
                });
            });
        });
        Promise.all(filePromises).then((results) => {
            setDocumentFiles(results);
            setDocErrors((prev) => ({ ...prev, aadhaar: null }));
        });
    };

    const handleDocumentUpload = (event) => processDocumentFiles(Array.from(event.target.files));

    const handleDocumentDrop = (event) => {
        event.preventDefault();
        setDragActive((prev) => ({ ...prev, aadhaar: false }));
        processDocumentFiles(Array.from(event.dataTransfer.files));
    };

    const handleRemoveAadhaarFile = () => {
        setDocumentFiles([]);
        const input = document.getElementById("aadhaar-document-input");
        if (input) input.value = "";
    };

    const handleCloseModal = () => {
        if (!submitting && !submittingPayLater) {
            setShowModal(false);
            setUploadedImages([]);
            setProfileFile(null);
            setDocumentFiles([]);
            setDocErrors({});
            setCurrentStep(0);
            setShowTooltip(false);
            formRef.current = null;
            formElementRef.current.reset();
        }
    };

    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    React.useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const isMobile = windowWidth <= 768;
    const isSmallScreen = windowWidth <= 576;

    const dragHandlers = (key) => ({
        onDragOver: (e) => { e.preventDefault(); setDragActive((p) => ({ ...p, [key]: true })); },
        onDragLeave: (e) => { e.preventDefault(); setDragActive((p) => ({ ...p, [key]: false })); },
    });

    const primaryBtnStyle = {
        backgroundColor: "#2DB9CA",
        border: "none",
        color: "white",
        padding: "10px 24px",
        borderRadius: "6px",
        fontWeight: "bold",
        fontSize: "16px",
        cursor: "pointer",
        boxShadow: "0 4px 6px rgba(0,0,0,0.2)",
    };

    const secondaryBtnStyle = {
        backgroundColor: "transparent",
        border: "2px solid #2DB9CA",
        color: "#2DB9CA",
        padding: "8px 22px",
        borderRadius: "6px",
        fontWeight: "bold",
        fontSize: "16px",
        cursor: "pointer",
    };

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                minHeight: "100vh",
                backgroundImage: `url(${registerimg})`,
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "top center",
                width: "100%",
            }}
        >
            {/* Top logos section */}
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: isMobile ? "10px" : "40px",
                    paddingTop: "30px",
                    paddingBottom: "10px",
                    marginBottom: "40px", // 👈 Pushes form downward
                    flexWrap: "wrap",
                }}
            >
                <img
                    src={group14}
                    alt="Goa GSCB Logo"
                    style={{
                        width: isMobile ? "80px" : "130px",
                        height: "auto",
                    }}
                />
                <img
                    src={alconlogo}
                    alt="Alcon Logo"
                    style={{
                        width: isMobile ? "80px" : "130px",
                        height: "auto",
                    }}
                />
                <img
                    src={unitycuplogo}
                    alt="GSB Unity Cup 2026 Logo"
                    style={{
                        width: isMobile ? "80px" : "130px",
                        height: "auto",
                    }}
                />
            </div>

            {/* Toast container placed properly */}
            <ToastContainer position="top-center" />

            {/* Main content section */}
            <div
                style={{
                    flexGrow: 1,
                    padding: "30px 15px",
                    backgroundColor: "rgba(0, 0, 0, 0.6)", // dark overlay for readability
                    color: "white",
                    textAlign: "center",
                }}
            >
                <h1 style={{ textShadow: "2px 2px 4px #000000", marginBottom: "10px" }}>
                    PLAYER REGISTRATION
                </h1>

                <p
                    style={{
                        color: "#2DB9CA",
                        textShadow: "2px 2px 4px #000000",
                        fontSize: "18px",
                        marginBottom: "30px",
                    }}
                >
                    {isRegistrationOpen
                        ? "Register with us and celebrate the spirit of cricket and community — Be a proud part of the GSB family!"
                        : "Registration is now closed. Stay tuned for next updates!"}
                </p>

                {/* Conditional form rendering */}
                {isRegistrationOpen ? (
                    <form
                        onSubmit={handleInitialSubmit}
                        onKeyDown={handleFormKeyDown}
                        name="contact-form"
                        ref={formElementRef}
                        style={{
                            maxWidth: "900px",
                            margin: "0 auto",
                            padding: "30px",
                            backgroundColor: "rgba(255, 255, 255, 0.1)",
                            borderRadius: "12px",
                            boxShadow: "0 0 10px rgba(0,0,0,0.3)",
                        }}
                    >
                        {/* PROGRESS BAR */}
                        <div style={{ maxWidth: "700px", margin: "0 auto 30px auto" }}>
                            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px", flexWrap: "wrap", gap: "4px" }}>
                                {STEP_LABELS.map((label, i) => (
                                    <span
                                        key={label}
                                        style={{
                                            fontSize: isSmallScreen ? "10px" : "13px",
                                            fontWeight: i === currentStep ? "bold" : "normal",
                                            color: i <= currentStep ? "#2DB9CA" : "#aaa",
                                        }}
                                    >
                                        {i + 1}. {label}
                                    </span>
                                ))}
                            </div>
                            <div style={{ width: "100%", height: "6px", backgroundColor: "rgba(255,255,255,0.2)", borderRadius: "3px", overflow: "hidden" }}>
                                <div
                                    style={{
                                        width: `${((currentStep + 1) / STEP_LABELS.length) * 100}%`,
                                        height: "100%",
                                        backgroundColor: "#2DB9CA",
                                        transition: "width 0.3s ease",
                                    }}
                                />
                            </div>
                        </div>

                        {/* STEP 1: PERSONAL INFO */}
                        <div ref={stepRefs[0]} style={{ display: currentStep === 0 ? "block" : "none" }}>
                            <div
                                style={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: "15px",
                                    justifyContent: "center",
                                }}
                            >
                                <div style={{ width: isSmallScreen ? "100%" : "30%", textAlign: "left" }}>
                                    <label style={{ color: "white", display: "block", marginBottom: "5px" }}>First Name *</label>
                                    <input type="text" placeholder="First Name" name="First-Name" className="form-control" required style={{ width: "100%" }} />
                                </div>
                                <div style={{ width: isSmallScreen ? "100%" : "30%", textAlign: "left" }}>
                                    <label style={{ color: "white", display: "block", marginBottom: "5px" }}>Last Name *</label>
                                    <input type="text" placeholder="Last Name" name="Last-Name" className="form-control" required style={{ width: "100%" }} />
                                </div>
                                <div style={{ width: isSmallScreen ? "100%" : "30%", textAlign: "left" }}>
                                    <label style={{ color: "white", display: "block", marginBottom: "5px" }}>Email ID *</label>
                                    <input type="email" placeholder="Email ID" name="Email-Id" className="form-control" required style={{ width: "100%" }} />
                                </div>
                                <div style={{ width: isSmallScreen ? "100%" : "30%", textAlign: "left" }}>
                                    <label style={{ color: "white", display: "block", marginBottom: "5px" }}>Mobile No. *</label>
                                    <input
                                        type="tel"
                                        placeholder="10-digit Mobile No."
                                        name="Mobile-No"
                                        className="form-control"
                                        required
                                        pattern="[0-9]{10}"
                                        maxLength={10}
                                        title="Enter a valid 10-digit mobile number"
                                        style={{ width: "100%" }}
                                    />
                                </div>
                                <div style={{ width: isSmallScreen ? "100%" : "30%", textAlign: "left" }}>
                                    <label style={{ color: "white", display: "block", marginBottom: "5px" }}>City *</label>
                                    <input type="text" placeholder="City" name="City" className="form-control" required style={{ width: "100%" }} />
                                </div>
                                <div style={{ width: isSmallScreen ? "100%" : "30%", textAlign: "left" }}>
                                    <label style={{ color: "white", display: "block", marginBottom: "5px" }}>State *</label>
                                    <select name="State" className="form-control" required defaultValue="GA" style={{ width: "100%", color: "grey" }}>
                                        <option value="GA">Goa</option>
                                    </select>
                                </div>
                                <div style={{ width: isSmallScreen ? "100%" : "30%", textAlign: "left" }}>
                                    <label style={{ color: "white", display: "block", marginBottom: "5px" }}>Gender *</label>
                                    <select
                                        name="Gender"
                                        className="form-control"
                                        required
                                        defaultValue="Male"
                                        style={{
                                            width: "100%",
                                            color: "black",
                                        }}
                                    >
                                        <option value="Male">Male</option>
                                        <option value="Female">Female</option>
                                    </select>
                                </div>
                                <div style={{ width: isSmallScreen ? "100%" : "30%", textAlign: "left" }}>
                                    <label style={{ color: "white", display: "block", marginBottom: "5px" }}>Mutt *</label>
                                    <select
                                        className="form-control"
                                        name="Mutt"
                                        defaultValue=""
                                        style={{
                                            width: "100%",
                                            fontSize: "15px",
                                            color: "black",
                                        }}
                                        required
                                    >
                                        <option value="" disabled>
                                            Choose Your Mutt
                                        </option>
                                        <option value="Kashi Mutt">Kashi Mutt</option>
                                        <option value="Kavle Mutt">Kavle Mutt</option>
                                        <option value="Gokrna Partagali Jevottam Mutt">
                                            Gokrna Partagali Jevottam Mutt
                                        </option>
                                        <option value="Chitrapur Mutt">Chitrapur Mutt</option>
                                    </select>
                                </div>
                                <div style={{ width: isSmallScreen ? "100%" : "30%", textAlign: "left" }}>
                                    <label style={{ color: "white", display: "block", marginBottom: "5px" }}>Date of Birth *</label>
                                    <input
                                        type="date"
                                        name="Date-of-Birth"
                                        className="form-control"
                                        placeholder="Date of Birth"
                                        required
                                        style={{ width: "100%" }}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* STEP 2: DOCUMENTS */}
                        <div ref={stepRefs[1]} style={{ display: currentStep === 1 ? "block" : "none" }}>
                            <div
                                style={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    justifyContent: "center",
                                    gap: "20px",
                                }}
                            >
                                <div style={{ width: isSmallScreen ? "100%" : "46%" }}>
                                    <FileDropzone
                                        label="Upload Profile Picture *"
                                        hint="* This profile picture will be used during the player auction"
                                        accept="image/*"
                                        file={profileFile}
                                        dragActive={dragActive.profile}
                                        inputId="profile-picture-input"
                                        onInputChange={handleProfileUpload}
                                        onDrop={handleProfileDrop}
                                        {...dragHandlers("profile")}
                                        onRemove={handleRemoveProfileFile}
                                        error={docErrors.profile}
                                    />
                                </div>
                                <div style={{ width: isSmallScreen ? "100%" : "46%" }}>
                                    <FileDropzone
                                        label="Upload Aadhaar Document *"
                                        accept=".pdf,.jpg,.jpeg,.png"
                                        file={documentFiles[0]}
                                        dragActive={dragActive.aadhaar}
                                        inputId="aadhaar-document-input"
                                        onInputChange={handleDocumentUpload}
                                        onDrop={handleDocumentDrop}
                                        {...dragHandlers("aadhaar")}
                                        onRemove={handleRemoveAadhaarFile}
                                        error={docErrors.aadhaar}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* STEP 3: PLAYER DETAILS */}
                        <div ref={stepRefs[2]} style={{ display: currentStep === 2 ? "block" : "none" }}>
                            <div style={{ textAlign: "center" }}>
                                <label style={{ fontWeight: "bold", display: "block", marginBottom: "10px" }}>PLAYER DETAILS</label>
                                <select
                                    name="Player-Details"
                                    className="form-select"
                                    required
                                    value={playerProfile}
                                    onChange={handlePlayerProfileChange}
                                    style={{
                                        width: isSmallScreen ? "100%" : "50%",
                                        margin: "0 auto 20px auto",
                                        boxShadow: "2px 2px 4px #000000",
                                    }}
                                >
                                    <option value="">Choose Your Profile</option>
                                    <option value="All Rounder">All Rounder</option>
                                    <option value="Bowler">Bowler</option>
                                    <option value="Batter">Batter</option>
                                    <option value="Wicket Keeper">Wicket Keeper</option>
                                </select>
                            </div>

                            {/* CONDITIONAL PLAYER FIELDS */}
                            {playerProfile === "All Rounder" && (
                                <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: "15px" }}>
                                    <select name="Batting-Hand" className="form-control" required style={{ width: isSmallScreen ? "100%" : "30%" }}>
                                        <option value="">Batting Style</option>
                                        <option value="Left Hand">Left Hand</option>
                                        <option value="Right Hand">Right Hand</option>
                                    </select>
                                    <select name="Batting-Ideal-Position" className="form-control" required style={{ width: isSmallScreen ? "100%" : "30%" }}>
                                        <option value="">Batting Position</option>
                                        <option value="Opener">Opener</option>
                                        <option value="Top Order (3-4)">Top Order (3-4)</option>
                                        <option value="Middle Order (5-7)">Middle Order (5-7)</option>
                                        <option value="Lower Order">Lower Order</option>
                                    </select>
                                    <select name="Batting-Skills" className="form-control" required style={{ width: isSmallScreen ? "100%" : "30%" }}>
                                        <option value="">Batting Skills</option>
                                        <option value="Steady Batter">Steady Batter</option>
                                        <option value="Finisher">Finisher</option>
                                        <option value="Bighitter">Big Hitter</option>
                                        <option value="Fast Starter">Fast Starter</option>
                                    </select>
                                    <select name="Bowling-Hand" className="form-control" required style={{ width: isSmallScreen ? "100%" : "30%" }}>
                                        <option value="">Bowling Arm</option>
                                        <option value="Right Arm">Right Arm</option>
                                        <option value="Left Arm">Left Arm</option>
                                    </select>
                                    <select name="Bowling-Specialization" className="form-control" required onChange={handleSpecializationChange} style={{ width: isSmallScreen ? "100%" : "30%" }}>
                                        <option value="">Bowling Speciality</option>
                                        <option value="Fast">Fast</option>
                                        <option value="Medium">Medium</option>
                                        <option value="Spin">Spin</option>
                                    </select>
                                    {specialization === "Spin" && (
                                        <select name="Bowling-Spin" className="form-control" required style={{ width: isSmallScreen ? "100%" : "30%" }}>
                                            <option value="">Spin Type</option>
                                            <option value="Leg Spin">Leg Spin</option>
                                            <option value="Off Spin">Off Spin</option>
                                        </select>
                                    )}
                                </div>
                            )}

                            {playerProfile === "Bowler" && (
                                <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: "15px" }}>
                                    <select name="Bowling-Hand" className="form-control" required style={{ width: isSmallScreen ? "100%" : "30%" }}>
                                        <option value="">Bowling Arm</option>
                                        <option value="Right Arm">Right Arm</option>
                                        <option value="Left Arm">Left Arm</option>
                                    </select>
                                    <select name="Specialization" className="form-control" required onChange={handleSpecializationChange} style={{ width: isSmallScreen ? "100%" : "30%" }}>
                                        <option value="">Bowling Speciality</option>
                                        <option value="Fast">Fast</option>
                                        <option value="Medium">Medium</option>
                                        <option value="Spin">Spin</option>
                                    </select>
                                    {specialization === "Spin" && (
                                        <select name="Spin" className="form-control" required style={{ width: isSmallScreen ? "100%" : "30%" }}>
                                            <option value="">Spin Type</option>
                                            <option value="Leg Spin">Leg Spin</option>
                                            <option value="Off Spin">Off Spin</option>
                                        </select>
                                    )}
                                </div>
                            )}

                            {playerProfile === "Batter" && (
                                <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: "15px" }}>
                                    <select name="Batting-Hand" className="form-control" required style={{ width: isSmallScreen ? "100%" : "30%" }}>
                                        <option value="">Batting Style</option>
                                        <option value="Left Hand">Left Hand</option>
                                        <option value="Right Hand">Right Hand</option>
                                    </select>
                                    <select name="Batting-Ideal-Position" className="form-control" required style={{ width: isSmallScreen ? "100%" : "30%" }}>
                                        <option value="">Batting Position</option>
                                        <option value="Opener">Opener</option>
                                        <option value="Top Order (3-4)">Top Order (3-4)</option>
                                        <option value="Middle Order (5-7)">Middle Order (5-7)</option>
                                        <option value="Lower Order">Lower Order</option>
                                    </select>
                                    <select name="Batting-Skills" className="form-control" required style={{ width: isSmallScreen ? "100%" : "30%" }}>
                                        <option value="">Batting Skills</option>
                                        <option value="Steady Batter">Steady Batter</option>
                                        <option value="Finisher">Finisher</option>
                                        <option value="Bighitter">Big Hitter</option>
                                        <option value="Fast Starter">Fast Starter</option>
                                    </select>
                                </div>
                            )}

                            {playerProfile === "Wicket Keeper" && (
                                <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: "15px" }}>
                                    <select name="Batting-Hand" className="form-control" required style={{ width: isSmallScreen ? "100%" : "30%" }}>
                                        <option value="">Batting Style</option>
                                        <option value="Left Hand">Left Hand</option>
                                        <option value="Right Hand">Right Hand</option>
                                    </select>
                                    <select name="Wicket-Keeper-Ideal-Position" className="form-control" required style={{ width: isSmallScreen ? "100%" : "30%" }}>
                                        <option value="">Batting Position</option>
                                        <option value="Opener">Opener</option>
                                        <option value="Top Order (3-4)">Top Order (3-4)</option>
                                        <option value="Middle Order (5-7)">Middle Order (5-7)</option>
                                        <option value="Lower Order">Lower Order</option>
                                    </select>
                                    <select name="Skills" className="form-control" required style={{ width: isSmallScreen ? "100%" : "30%" }}>
                                        <option value="">Skills</option>
                                        <option value="Steady Batter">Steady Batter</option>
                                        <option value="Finisher">Finisher</option>
                                        <option value="Bighitter">Big Hitter</option>
                                        <option value="Fast Starter">Fast Starter</option>
                                    </select>
                                </div>
                            )}
                        </div>

                        {/* STEP 4: AVAILABILITY & AGREEMENT */}
                        <div ref={stepRefs[3]} style={{ display: currentStep === 3 ? "block" : "none" }}>
                            <div style={{ textAlign: "center" }}>
                                <label style={{ fontWeight: "bold", display: "block", marginBottom: "10px" }}>
                                    AVAILABILITY *
                                </label>
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        gap: "30px",
                                        flexWrap: "wrap",
                                    }}
                                >
                                    <label style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer" }}>
                                        <input type="radio" name="Availability" value="Saturday & Sunday" required />
                                        Saturday & Sunday
                                    </label>
                                    <label style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer" }}>
                                        <input type="radio" name="Availability" value="Sunday Only" required />
                                        Sunday Only
                                    </label>
                                </div>
                            </div>

                            {/* INJURY WAIVER / TERMS AGREEMENT */}
                            <div style={{ maxWidth: "700px", margin: "30px auto 0 auto", textAlign: "left" }}>
                                <label
                                    style={{
                                        display: "flex",
                                        alignItems: "flex-start",
                                        gap: "10px",
                                        cursor: "pointer",
                                        fontSize: "14px",
                                        lineHeight: "1.5",
                                    }}
                                >
                                    <input
                                        type="checkbox"
                                        name="Injury-Waiver"
                                        value="Agreed"
                                        required
                                        style={{ marginTop: "4px", flexShrink: 0 }}
                                    />
                                    <span>
                                        I have read and agree to the{" "}
                                        <button
                                            type="button"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                setShowConsentModal(true);
                                            }}
                                            style={{
                                                background: "none",
                                                border: "none",
                                                padding: 0,
                                                color: "#2DB9CA",
                                                textDecoration: "underline",
                                                cursor: "pointer",
                                                fontSize: "inherit",
                                                fontFamily: "inherit",
                                            }}
                                        >
                                            Liability Waiver &amp; Consent Form
                                        </button>
                                        , and I accept the tournament's refund policy for injury-related or
                                        post-auction withdrawals. *
                                    </span>
                                </label>
                            </div>
                        </div>

                        {/* STEP NAVIGATION */}
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                maxWidth: "700px",
                                margin: "30px auto 0 auto",
                            }}
                        >
                            {currentStep > 0 ? (
                                <button type="button" onClick={handleBack} style={secondaryBtnStyle}>
                                    ← Back
                                </button>
                            ) : (
                                <span />
                            )}

                            {currentStep < STEP_LABELS.length - 1 ? (
                                <button type="button" onClick={handleNext} style={primaryBtnStyle}>
                                    Next →
                                </button>
                            ) : (
                                <input
                                    type="submit"
                                    value={submitting ? "Submitting..." : "Proceed to Payment"}
                                    className="btn btn-primary"
                                    style={primaryBtnStyle}
                                    disabled={submitting}
                                />
                            )}
                        </div>
                    </form>
                ) : (
                    <div
                        style={{
                            maxWidth: "900px",
                            margin: "0 auto",
                            padding: "60px 30px",
                            backgroundColor: "rgba(255, 255, 255, 0.1)",
                            borderRadius: "12px",
                            boxShadow: "0 0 10px rgba(0,0,0,0.3)",
                            textAlign: "center",
                        }}
                    >
                        <div style={{ fontSize: "48px", marginBottom: "20px" }}>🚫</div>
                        <h2 style={{
                            color: "#ff6b6b",
                            marginBottom: "20px",
                            textShadow: "2px 2px 4px #000000"
                        }}>
                            Registration Closed
                        </h2>
                        <p style={{
                            fontSize: "20px",
                            marginBottom: "30px",
                            color: "#ffffff"
                        }}>
                            Thank you for your interest in the GSB Unity Cup 2026!
                        </p>
                        <p style={{
                            fontSize: "18px",
                            marginBottom: "20px",
                            color: "#cccccc"
                        }}>
                            Player registration for this tournament has now closed.
                        </p>
                        <p style={{
                            fontSize: "16px",
                            color: "#2DB9CA",
                            fontWeight: "bold"
                        }}>
                            Stay tuned for future tournaments and updates!
                        </p>
                    </div>
                )}

                {showModal && (
                    <>
                        <div
                            className={`modal fade ${showModal ? "show" : ""}`}
                            style={{ display: showModal ? "block" : "none" }}
                            tabIndex="-1"
                            role="dialog"
                            aria-labelledby="paymentModalLabel"
                            aria-hidden={!showModal}
                        >
                            <div className="modal-dialog modal-xl" role="document">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h3 className="modal-title mx-auto" style={{ color: "black", fontWeight: "bold" }}>
                                            Payment Options
                                        </h3>
                                        <button type="button" className="close" onClick={handleCloseModal} aria-label="Close">
                                            <span aria-hidden="true">×</span>
                                        </button>
                                    </div>
                                    <div className="modal-body">
                                        <div style={{ textAlign: "center", marginBottom: "20px" }}>
                                            <span
                                                style={{
                                                    display: "inline-block",
                                                    backgroundColor: "#28a745",
                                                    color: "white",
                                                    fontWeight: "bold",
                                                    fontSize: "20px",
                                                    padding: "8px 24px",
                                                    borderRadius: "6px",
                                                }}
                                            >
                                                Amount to Pay: ₹3000
                                            </span>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-6" style={{ textAlign: "center" }}>
                                                <h4 style={{ color: "black", fontWeight: "bold" }}>Scan to Pay</h4>
                                                <img
                                                    src={QRcodebank}
                                                    alt="QR Code for Payment"
                                                    style={{ maxWidth: "100%", height: isMobile ? "35vh" : "50vh" }}
                                                />
                                            </div>
                                            <div className="col-md-6">
                                                <h4 style={{ color: "black", fontWeight: "bold" }}>Account Details</h4>
                                                <div style={{ color: "black", marginTop: "10px" }}>
                                                    {[
                                                        { label: "Account number:", value: "CAGEN/610000000054236" },
                                                        { label: "Account name:", value: "GOA GSB SPORTS AND CHARITABLE TRUST" },
                                                        { label: "Bank name:", value: "Saraswat Co-operative Bank" },
                                                        { label: "Branch IFSC Code:", value: "SRCB0000096" },
                                                        { label: "Branch:", value: "Ponda, Goa" },
                                                        { label: "Branch MICR Code:", value: "403088006" },
                                                    ].map((item, index) => (
                                                        <div
                                                            key={index}
                                                            style={{ display: "flex", justifyContent: "space-between", marginBottom: "5px" }}
                                                        >
                                                            <span style={{ fontWeight: "500" }}>{item.label}</span>
                                                            <span>{item.value}</span>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mt-4">
                                            <div className="col-12">
                                                <div style={{ maxWidth: "400px", margin: "0 auto 15px auto" }}>
                                                    <FileDropzone
                                                        label="Upload Payment Screenshot"
                                                        hint="Making a split payment? Upload one screenshot per transaction."
                                                        accept="image/*"
                                                        files={uploadedImages}
                                                        multiple
                                                        dragActive={dragActive.screenshot}
                                                        inputId="screenshot-input"
                                                        onInputChange={handleImageUpload}
                                                        onDrop={handleScreenshotDrop}
                                                        {...dragHandlers("screenshot")}
                                                        onRemove={handleRemoveScreenshot}
                                                        theme="light"
                                                    />
                                                </div>
                                                <div style={{ textAlign: "center" }}>
                                                    <button
                                                        type="button"
                                                        className="btn"
                                                        onClick={handleFinalSubmit}
                                                        disabled={uploadedImages.length === 0 || submitting}
                                                        style={{
                                                            backgroundColor: "#28a745",
                                                            color: "white",
                                                            border: "none",
                                                            padding: "10px 20px",
                                                            borderRadius: "6px",
                                                        }}
                                                    >
                                                        {submitting ? "Submitting..." : "Upload Payment Receipt"}
                                                    </button>
                                                </div>
                                            </div>
                                            <div>
                                                <p
                                                    style={{
                                                        color: "#000000",
                                                        marginBottom: "0",
                                                    }}
                                                >
                                                    Terms & Conditions – Player Registration Fee <br />
                                                    Refundable (within 7 working days) only if: <br />
                                                    1. The player is not picked by any franchise/team during the official Players Auction. <br />
                                                    Non-Refundable under the following conditions:<br />
                                                    1. The player withdraws from the tournament after the completion of the Players Auction, regardless of reason.<br />
                                                    2. The player withdraws due to injury — whether on or off the field, before or during the tournament.<br />
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-backdrop fade show" onClick={handleCloseModal} />
                    </>
                )}

                {showConsentModal && (
                    <>
                        <div
                            className={`modal fade ${showConsentModal ? "show" : ""}`}
                            style={{ display: showConsentModal ? "block" : "none" }}
                            tabIndex="-1"
                            role="dialog"
                            aria-labelledby="consentModalLabel"
                            aria-hidden={!showConsentModal}
                        >
                            <div className="modal-dialog modal-lg" role="document">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h3 className="modal-title mx-auto" style={{ color: "black", fontWeight: "bold" }}>
                                            Liability Waiver & Consent Form
                                        </h3>
                                        <button
                                            type="button"
                                            className="close"
                                            onClick={() => setShowConsentModal(false)}
                                            aria-label="Close"
                                        >
                                            <span aria-hidden="true">×</span>
                                        </button>
                                    </div>
                                    <div
                                        className="modal-body"
                                        style={{ color: "black", textAlign: "left", maxHeight: "65vh", overflowY: "auto" }}
                                    >
                                        <p style={{ fontWeight: "bold", textAlign: "center" }}>
                                            ALCON GSB UNITY CUP 2026<br />
                                            LIABILITY WAIVER AND RELEASE FORM
                                        </p>
                                        <p>
                                            I, the undersigned participant, understand and acknowledge that playing cricket,
                                            including participation in the ALCON GSB UNITY CUP 2026, involves inherent risks,
                                            including but not limited to personal injury, damage to property, and even death.
                                            I agree to assume full responsibility for any risks, injuries, or damages incurred
                                            while participating in the tournament.
                                        </p>

                                        <p style={{ fontWeight: "bold", marginBottom: "4px" }}>Release of Liability:</p>
                                        <p>
                                            I, on behalf of myself, my heirs, executors, and administrators, hereby fully and
                                            forever release, discharge, and hold harmless the ALCON GSB UNITY CUP 2026
                                            organizers, sponsors, volunteers, and any other entities or individuals associated
                                            with the event (the "Releasees") from any and all claims, demands, actions, or
                                            causes of action related to personal injury, death, or property damage arising
                                            out of my participation in the ALCON GSB UNITY CUP 2026.
                                        </p>
                                        <p>
                                            I understand that the Releasees are not responsible for any injury or loss
                                            resulting from my participation, including any injury that may result from my own
                                            actions, or the actions of others, while participating in the event.
                                        </p>

                                        <p style={{ fontWeight: "bold", marginBottom: "4px" }}>Medical Consent:</p>
                                        <p>
                                            I consent to receive medical treatment, if necessary, in the event of injury,
                                            accident, or illness during my participation in the ALCON GSB UNITY CUP 2026. I
                                            agree to be financially responsible for any and all medical costs incurred as a
                                            result and will not hold the Organisers responsible in any circumstances.
                                        </p>

                                        <p style={{ fontWeight: "bold", marginBottom: "4px" }}>Code of Conduct:</p>
                                        <p>
                                            I agree to comply with the rules, regulations, and conduct standards set by the
                                            ALCON GSB UNITY CUP 2026 organizers. I understand that failure to adhere to this
                                            tournament's rules or engaging in unsportsmanlike conduct may result in my
                                            disqualification from the event.
                                        </p>

                                        <p style={{ fontWeight: "bold", marginBottom: "4px" }}>Photography and Media Release:</p>
                                        <p>
                                            I grant permission to the ALCON GSB UNITY CUP 2026 organizers and their
                                            affiliates to use any photographs, video recordings, or other media involving my
                                            image or participation for promotional purposes without compensation.
                                        </p>

                                        <p>
                                            By signing this form, I acknowledge that I have read and understood the terms
                                            and conditions of this liability waiver. I am fully aware of the risks associated
                                            with participating in the ALCON GSB UNITY CUP 2026 and voluntarily assume those
                                            risks.
                                        </p>

                                        <p style={{ fontSize: "13px", fontStyle: "italic", marginBottom: 0 }}>
                                            *A copy of the parent's or guardian's ID card must be attached in case the
                                            participant is under 18 years of age.
                                        </p>
                                    </div>
                                    <div className="modal-footer">
                                        <button
                                            type="button"
                                            className="btn"
                                            onClick={() => setShowConsentModal(false)}
                                            style={{
                                                backgroundColor: "#28a745",
                                                color: "white",
                                                border: "none",
                                                padding: "8px 20px",
                                                borderRadius: "6px",
                                            }}
                                        >
                                            Close
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-backdrop fade show" onClick={() => setShowConsentModal(false)} />
                    </>
                )}

                {submitting && (
                    <div
                        style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            backgroundColor: "rgba(0, 0, 0, 0.75)",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            zIndex: 2000,
                        }}
                    >
                        <img
                            src={alconlogo}
                            alt="Alcon Logo"
                            style={{ width: "90px", height: "90px", objectFit: "contain", marginBottom: "12px", borderRadius: "50%" }}
                        />
                        <img
                            src={unitycuplogo}
                            alt="GSB Unity Cup 4.0 Logo"
                            style={{ width: "120px", height: "120px", objectFit: "contain", marginBottom: "20px" }}
                        />
                        <div
                            style={{
                                width: "40px",
                                height: "40px",
                                border: "4px solid rgba(255,255,255,0.3)",
                                borderTopColor: "#2DB9CA",
                                borderRadius: "50%",
                                animation: "spin 1s linear infinite",
                                marginBottom: "16px",
                            }}
                        />
                        <p style={{ color: "white", fontSize: "20px", fontWeight: "bold", margin: 0 }}>
                            Registering with Alcon GSB Unity Cup 4.0...
                        </p>
                        <style>
                            {`@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }`}
                        </style>
                    </div>
                )}
            </div>

            {/* Footer */}
            <footer
                style={{
                    padding: "10px",
                    backgroundColor: "#000",
                    color: "#fff",
                    textAlign: "center",
                }}
            >
                <p style={{ margin: "5px 0" }}>
                    Copyright © 2025 - 2026 GSB Sports & Charitable Trust
                </p>
                <p style={{ margin: "0" }}>
                    Website done by{" "}
                    <span
                        style={{
                            color: "#2DB9CA",
                            display: "inline",
                            textShadow: "2px 2px 4px #000000",
                        }}
                    >
                        ThryvTechLabs
                    </span>
                </p>
            </footer>
        </div>
    );
}

export default Register;
